module.exports = __webpack_public_path__ + "img/2023-04-25 21.29.34.83d865c8.jpg";